import api from "../services/api";

export default {
    namespaced: true,
    state: {
        gp: {
            loading: false,
            loadError: "",
            gpReports: [],
            byDate: {
                loading: false,
                loadError: "",
                gpReportsByDate: []
            }
        },
        order: {
            loading: false,
            loadError: "",
            orders: [],
            totalOrders: 0,
            detailed: {
                loading: false,
                loadError: "",
                data: []
            }
        }
    },
    getters: {

    },
    mutations: {
        setGPReports(state, data) {
            state.gp.gpReports = data;
        },
        loadingGPReports(state) {
            state.gp.loading = true;
            state.gp.loadError = "";
        },
        loadGPReportsComplete(state) {
            state.gp.loading = false;
        },
        loadGPReportsError(state, err) {
            state.gp.gpReports = [];
            state.gp.loadError = err;
        },
        setGPReportsByDate(state, data) {
            state.gp.byDate.gpReportsByDate = data;
        },
        loadingGPReportsByDate(state) {
            state.gp.byDate.loading = true;
            state.gp.byDate.loadError = "";
        },
        loadGPReportsByDateComplete(state) {
            state.gp.byDate.loading = false;
        },
        loadGPReportsByDateError(state, err) {
            state.gp.byDate.gpReportsByDate = [];
            state.gp.byDate.loadError = err;
        },
        setOrderReports(state, data) {
            state.order.orders = data;
        },
        loadingOrderReports(state) {
            state.order.loading = true;
            state.order.loadError = "";
        },
        loadOrderReportsComplete(state) {
            state.order.loading = false;
        },
        loadOrderReportsError(state, err) {
            state.order.orders = [];
            state.order.totalOrders = 0;
            state.order.loadError = err;
        },
        setTotalOrders(state, number){
            state.order.totalOrders = number;
        },
        setDetailedOrderReport(state, data) {
            state.order.detailed.data = data;
        },
        loadingDetailedOrderReport(state) {
            state.order.detailed.loading = true;
            state.order.detailed.loadError = "";
        },
        loadDetailedOrderReportComplete(state) {
            state.order.detailed.loading = false;
        },
        loadDetailedOrderReportError(state, err) {
            state.order.detailed.data = [];
            state.order.detailed.loadError = err;
        },
    },
  
    actions: {
        clearGPReports(context){
            context.commit("setGPReports", []);
        },
        loadGPReports(context, options) {
            context.commit("loadingGPReports");

            api.fetchGPReports({
                params: options.params,
                success: function(response) {
                    context.commit("setGPReports", response.data.GPReports);

                    if (options.success) {
                        options.success(response.data);
                    }
                },
                error: function(e) {
                    context.commit("loadGPReportsError", api.parseHttpRequestError(e));

                    if (options.error) {
                        options.error(e);
                    }
                },
                finally: function() {
                    context.commit("loadGPReportsComplete");

                    if (options.finally) {
                        options.finally();
                    }
                }
            });
        },
        clearGPReportsByDate(context){
            context.commit("setGPReportsByDate", []);
        },
        loadGPReportsByDate(context, options) {
            context.commit("loadingGPReportsByDate");

            api.fetchGPReportsByDate({
                params: options.params,
                success: function(response) {
                    context.commit("setGPReportsByDate", response.data.GPReportsByDate);

                    if (options.success) {
                        options.success(response.data);
                    }
                },
                error: function(e) {
                    context.commit("loadGPReportsByDateError", api.parseHttpRequestError(e));

                    if (options.error) {
                        options.error(e);
                    }
                },
                finally: function() {
                    context.commit("loadGPReportsByDateComplete");

                    if (options.finally) {
                        options.finally();
                    }
                }
            });
        },
        clearOrderReports(context) {
            context.commit("setOrderReports", []);
        },
        loadOrderSentReports(context, options) {
            context.commit("loadingOrderReports");

            api.fetchOrderReports({
                params: options.params,
                success: function (response) {
                    context.commit("setOrderReports", response.data.Orders);
                    context.commit("setTotalOrders", response.data.TotalOrders);

                    if (options.success) {
                        options.success(response.data);
                    }
                },
                error: function (e) {
                    context.commit("loadOrderReportsError", api.parseHttpRequestError(e));

                    if (options.error) {
                        options.error(e);
                    }
                },
                finally: function () {
                    context.commit("loadOrderReportsComplete");

                    if (options.finally) {
                        options.finally();
                    }
                }
            });
        },
        loadDetailedOrderReport(context, options) {
            context.commit("loadingDetailedOrderReport");

            api.fetchDetailedOrderReport({
                params: options.params,
                success: function (response) {
                    context.commit("setDetailedOrderReport", response.data);

                    if (options.success) {
                        options.success(response.data);
                    }
                },
                error: function (e) {
                    context.commit("loadDetailedOrderReportError", api.parseHttpRequestError(e));

                    if (options.error) {
                        options.error(e);
                    }
                },
                finally: function () {
                    context.commit("loadDetailedOrderReportComplete");

                    if (options.finally) {
                        options.finally();
                    }
                }
            });
        },
    }
}
